var rich_content_viewer_default = {
  "fontElementMap": "P9Y6r",
  "wrapper": "LUDJN",
  "pluginContainerMobile": "QSwwG",
  "viewer": "ErHoM",
  "android": "CYWd0",
  "rootedTraversedContent": "qct9t",
  "atomic": "pI2qi",
  "toolbar": "_1dL5B",
  "block": "hPyf-"
};
export {
  rich_content_viewer_default as default
};
//# sourceMappingURL=rich-content-viewer-scss.js.map
